<input
  type="file"
  accept="application/pdf"
  (change)="verificarPdf($event)"
/>

<p *ngIf="resultado !== null">
  PDF tem senha? <strong>{{ resultado ? 'SIM' : 'NÃO' }}</strong>
</p>
